module.exports = __webpack_public_path__ + "img/leo.700fc535.png";